import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, renderSlot as _renderSlot, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "overflow-x-scroll" }
const _hoisted_2 = { class: "w-space-nowrap ps-0 mb-0" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ScrollHorizontal',
  props: {
    items: { default: () => [] }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items, (item, index) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "d-inline-block me-4",
          key: index
        }, [
          _renderSlot(_ctx.$slots, "default", { item: item })
        ]))
      }), 128))
    ])
  ]))
}
}

})